<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :span="12">
              <label class="title">审核统计报表</label>
              <a-range-picker @change="onChange" />
              <a-button style="margin-left: 20px" @click="queryData" type="primary" icon="search">查询</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- table区域-begin -->
      <div>
        <a-table
          ref="table"
          class="table-with-parent-col-border"
          size="middle"
          rowKey="personId"
          :columns="columns"
          :dataSource="dataSource"
          :scroll="{x:`${width}`,y:'calc(100vh - 350px)'}"
          :pagination="false"
          :loading="loading"
          @change="handleTableChange">
          
        </a-table>
      </div>
    </a-card>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import { getAction,postAction} from '@/api/manage'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'AuditData',
    mixins: [JeecgListMixin],
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        centerName:'',
        columns: [],
        url: {
          list: "/project/projectAuditSummary/getSummaryAudit",
        },
        width:100,
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      this.queryParam.projectId = this.projectId
      this.loadColumn()
      // this.loadData()
    },
    watch:{
    },
    methods:{
      onChange(date, dateString){
        this.queryParam.startDate=dateString[0]
        this.queryParam.endDate=dateString[1]
        // this.loadData()
      },
      queryData(){        
        if(this.queryParam.startDate == '' || !this.queryParam.startDate || this.queryParam.endDate == '' || !this.queryParam.endDate){
          this.$message.error('请选择时间范围')
          return
        }
        this.loadData()
      },
      async loadColumn(){
        // 添加 周期的column
        const columns = [
          {
            title: '审核员',
            align:"center",
            width: 100,
            dataIndex: 'personName'
          }, 
          {
            title: '提出质疑数',
            align:"center",
            width: 100,
            dataIndex: 'submitQuestion'
          },
          {
            title: '关闭质疑数',
            align:"center",
            width: 100,
            dataIndex: 'replyQuestion'
          },                   
        ]        
        // 添加 周期column
        let periodItemData = []
        await getAction('/project/projectPeriodItem/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            periodItemData = res.result
          }
        })
        periodItemData.forEach(periodItem=>{
          columns.push({
            title: periodItem.name,            
            align:"center",
            children:[
              {
                title: "病例数",
                align:"center",
                children:[
                    {
                        title: "已审核",
                        align:"center",
                        width: 100,
                        dataIndex: 'auditedPatient_'+periodItem.id,
                    },
                    {
                        title: '审核中',
                        align:"center",
                        width: 100,
                        dataIndex: 'auditingPatient_'+periodItem.id,
                    },
                    {
                        title: '未审核',
                        align:"center",
                        width: 100,
                        dataIndex: 'unAuditPatient_'+periodItem.id,
                    },
                    {
                        title: '完成比例',
                        align:"center",
                        width: 130,
                        dataIndex: 'auditedPatientRate_'+periodItem.id,
                    }, 
                ],
              },
              {
                title: "表单数",
                align:"center",
                customCell: () => ({class:  'col-divider' }),
                customHeaderCell: () => ({ class: 'parent-col-end' }),
                children:[
                    {
                        title: "已审核",
                        align:"center",
                        width: 120,
                        dataIndex: 'auditedForm_'+periodItem.id,
                    },
                    {
                        title: '审核中',
                        align:"center",
                        width: 100,
                        dataIndex: 'auditingForm_'+periodItem.id,
                    },
                    {
                        title: '未审核',
                        align:"center",
                        width: 100,
                        dataIndex: 'unAuditForm_'+periodItem.id,
                    },
                    {
                        title: '完成比例',
                        align:"center",
                        width: 130,
                        dataIndex: 'auditedFormRate_'+periodItem.id,
                        customCell: () => ({class:  'col-divider' }),
                        customHeaderCell: () => ({ class: 'parent-col-end' })
                    },
                ]
              },                       
            ]
          })
        })        
        this.width = 800 + periodItemData.length*160

        this.columns = columns
      }
    }
  }
</script>

<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
  :deep(.parent-col-end) {
  border-right: 1px solid #e0dede !important;
}
:deep(.col-divider) {
  border-right: 1px solid #e0dede !important;
}
</style>